import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  resetNextUuid,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import useInView from "react-cool-inview";
import { useEffect, useState } from 'react';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import Image from 'next/image';


const Questions = (props) => {

  const [ready, setReady] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])

  const { observe, unobserve, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });

  resetNextUuid();



  return (
    <div
      className={
        props.home && props.type == "covid"
          ? "section-gap question-main remove-waves"
          : "section-gap question-main"
      }
      ref={observe}
    >
      {/* <div class="wave-container-top d-block">
        <img src="/waves-top.webp" />
      </div> */}
      {inView && (
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="question-h1 section-title text-start">
                <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "45px" }}>
                  <h2 className="question-title mt-4">Questions?</h2>
                </ReactPlaceholder>

              </div>
            </div>
            <div className="col-md-12 ">
              <div className="custom-accodion">
                <Accordion allowZeroExpanded="false">
                  {props.questions.map((item, key) => (
                    <AccordionItem key={key} className="">
                      <AccordionItemHeading>
                        <AccordionItemButton >
                          <div className="fq-hover-div">
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px" }}>

                              <Image
                                height={18}
                                width={18}
                                src="/images/faq-logo.webp"
                                alt="Logo Next Med"
                                className="faq-logo"
                              />
                              <span className="span-heading">

                                {item.question}
                              </span>
                            </ReactPlaceholder>

                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                  {props?.dki && props.dki.toLowerCase() == "wegovy" && (
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <div className="fq-hover-div">
                            <img
                              src="/images/faq-logo.webp"
                              alt="Logo Next Med"
                              className="faq-logo"
                            />
                            <span className="span-heading">
                              Is there a Wegovy Shortage? Am I guaranteed to get
                              Wegovy?
                            </span>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        Yes, unfortunately there is currently a shortage of
                        Wegovy which will likely persist until at least early
                        Fall 2022. Some pharmacies have Wegovy in stock while
                        many do not. By joining our program, if eligible, you
                        are guaranteed to receive a GLP-1a prescription of
                        Wegovy or a drug like Wegovy that is in stock. If your
                        pharmacy has Wegovy in stock, your doctor will be able
                        to prescribe it. If it does not, your doctor will offer
                        you Ozempic or Saxenda, two GLP-1 drugs which have shown
                        similar weight loss properties as Wegovy (and are
                        manufactured by the same pharmaceutical company). No
                        company today can guarantee that you will be able to
                        receive Wegovy as the supply issues affect everyone
                        equally.
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                  {props?.type && props.type.toLowerCase() == "ozempic" && (
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <div className="fq-hover-div">
                            <img
                              src="/images/faq-logo.webp"
                              alt="Logo Next Med"
                              className="faq-logo"
                            />
                            <span className="span-heading">
                              Is Ozempic FDA-Approved for Weight Loss?
                            </span>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        No, Ozempic is not FDA-approved for weight loss. Independent healthcare professionals have the discretion to prescribe a medication off-label if they believe it is an appropriate course of treatment for a particular patient. In this situation, your provider may choose to prescribe Ozempic for weight-loss at their sole discretion.
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                  {props?.type && props.type.toLowerCase() == "mounjaro" && (
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <div className="fq-hover-div">
                            <img
                              src="/images/faq-logo.webp"
                              alt="Logo Next Med"
                              className="faq-logo"
                            />
                            <span className="span-heading">
                              Is Mounjaro FDA-Approved for Weight Loss?

                            </span>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        No, Mounjaro is not FDA-approved for weight loss. Independent healthcare professionals have the discretion to prescribe a medication off-label if they believe it is an appropriate course of treatment for a particular patient. In this situation, your provider may choose to prescribe Mounjaro for weight-loss at their sole discretion.
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      {/* <div class="wave-container-bottom d-block">
        <img src="/waves.webp" />
      </div> */}
    </div>
  );
};
export default Questions;
